import {FC, ReactNode} from 'react'
import {Link} from 'react-router-dom'
import {URL, WebSite, isAPP} from '../../../../_metronic/helpers'
import {AppBackdrop} from '../../../theme/AppBackdrop'
import {BrandLockup} from '../../../theme/BrandLogo'
import '../components/Login.css'
import './AccountCompletion.css'

type Props = {
  /** Who is signed in, beside «خروج»; nothing when no one is (the sign-in link page opened signed out). */
  userLabel?: string
  signOut?: boolean
  children: ReactNode
}

/**
 * The sign-in pages' look (site backdrop, logo bar, one white tile) for the pages a person goes through before the
 * panel: «تکمیل حساب کاربری» and the sign-in link's «تعیین نام کاربری و رمز عبور». No side menu or header.
 */
export const AccountEntryLayout: FC<Props> = ({userLabel, signOut = false, children}) => (
  <div className='auth-page-container account-entry'>
    <AppBackdrop site />

    <header className='auth-topbar'>
      <BrandLockup href={(isAPP ? URL : WebSite) || '/'} />
      {signOut && (
        <div className='account-entry__user'>
          {userLabel && (
            <span className='account-entry__name'>
              <i className='las la-user-circle' aria-hidden='true' />
              <bdi>{userLabel}</bdi>
            </span>
          )}
          <Link to='/logout' className='auth-topbar__badge account-entry__signout'>
            <i className='las la-sign-out-alt' aria-hidden='true' /> خروج
          </Link>
        </div>
      )}
    </header>

    <main className='auth-main account-entry__main'>
      <section className='auth-card account-entry__card'>{children}</section>
    </main>
  </div>
)
